module.exports = __webpack_public_path__ + "static/assets/99b8cc7a257c32e4ebe6b8641c446516.svg";